import { getCurrentDevice, isValidDate } from './utils';
import moment from 'moment';

import scrollAnimations from './scroll-animations';
import fullsizeImagesUI from './fullsize';
import slidersUI from './sliders';
import filtersUI from './filtersUI';
import currentYear from './current-year';
import adaUI from './ada';
import shaveUI from './shave-ui';
import readMoreUI from './read-more-ui';
import mapsUI from './maps-ui';
import navigationUI from './navigation-ui';
import headerUI from './header-ui';
import footerUI from './footer-ui';
import bookingMaskUI from './booking-mask-ui';
import faqUI from './faq-ui';
import initSelects from './select';
import initMapsLinks from './maps-link';
import qtyUI from './qty-ui';
import tabsOnHoverUI from './tabs-on-hover-ui';
import blogGridArticlesUI from './blog-grid-articles-ui';
import testimonialsUI from './testimonials-ui';
import faqsCategoryUI from './faqs-category-ui';
import soloCategoryFilter from './solo-category-filter';
import AOS from 'aos';
import initBookingMask from './BookingMask';
import initGMS from './modules/module-gms';
import personalizationUI from './modules/personalizationUI';
import EventTracking from "tc-event-tracking";

;(function(window, document, $) {
	$('.js-move').each(function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		$target.append($this);
	});

	$('.js-bm-hero').on('click', function() {
		$('.bm--header').removeClass('active');
		$('.js-toggle-bm-header').removeClass('active');
		$('body').removeClass('bm-open');
		// $('body').removeClass('bm-modal-open');

	});

	$('.js-booking-form').on('submit', function(event) {
		const $locationField = $(this).find('.js-bm-hotel-selected');
		const locationFieldValue = $locationField.val();
		const locationFieldDefaultValue = $locationField.data('value');
		const siteId = $locationField.data('website-id')
		const $errorMessage = $locationField.siblings('.js-location-error-message');

		if (locationFieldDefaultValue === locationFieldValue && siteId == 2) {
			$errorMessage.removeClass('d-none');
			$locationField.parents('.bm__group').addClass('error');
		} else {
			$errorMessage.addClass('d-none');
			$locationField.parents('.bm__group').removeClass('error');
		}
	});

  //JS Year
  $('.js-footer-year').text(moment().year());

	$('.js-bm-hotel-selected').on('change', function() {
		const $locationField = $(this);
		const locationFieldValue = $locationField.val();
		const locationFieldDefaultValue = $locationField.data('value');
		const siteId = $locationField.data('website-id')
		const $errorMessage = $locationField.siblings('.js-location-error-message');

		if (locationFieldDefaultValue === locationFieldValue && siteId == 2) {
			//
		} else {
			$errorMessage.addClass('d-none');
			$locationField.parents('.bm__group').removeClass('error');
		}
	});

	$('.js-mousemove').on('mouseenter', function() {
		$('.wrapper').addClass('toggle-overlay')
	});

	$('.js-mousemove').on('mouseleave', function() {
		$('.wrapper').removeClass('toggle-overlay')
	});

	$('a[href^="tel"]').each(function() {
		const linkHref = $(this).attr('href');

		$(this).attr('href', linkHref.replace(/ /igm, ''));
	});

	$('.js-trim-decimals').each(function() {
		const number = Math.trunc($(this).text());

		$(this).text(number);
	});

	initGMS();

	$('.js-add-commas').each(function() {
		const number = $(this).text();
		const length = number.length;

		if ( length > 3 ) {
			$(this).text(number.slice(0, length - 3) + ',' + number.slice(length - 3,length));
		}
	});

	$('.js-date').each(function() {
		const $this = $(this);
		const dateText = $this.data('date') ? $this.data('date') : $this.text();
		const date = moment(dateText);
		const format = $this.data('format');

		if ( date.isValid() ) {
			$this.html(date.format(format));
		} else {
			$this.remove();
		}
	});

	$('.js-scroll-top').on('click', function() {
		$('html, body').animate({
			scrollTop: 0
		});
	})

	AOS.init({
		duration: 700,
		easing: 'ease-in-cubic',
		once: true,
		disable: 'mobile'
	});

	$('.js-set-url').on('change', function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		$target.attr('href', $this.val());
	});

	if ($('.is-page-blog').length > 0) {
		$('body').addClass('page-blog');
	}

	if ( $('.is-page-blog').length ) {
		$('.wrapper').addClass('wrapper--blog')
	}

	EventTracking.init();

	fullsizeImagesUI();

	slidersUI();

	filtersUI();

	adaUI();

	// Add js-year-container class where you want to print the current year
	currentYear();

	shaveUI();

	readMoreUI();

	mapsUI();

	headerUI();

	navigationUI();

	footerUI();

	bookingMaskUI();

	qtyUI();

	faqUI();

	initSelects();

	initMapsLinks();

	tabsOnHoverUI();

	blogGridArticlesUI();

	testimonialsUI();

	faqsCategoryUI();

	initBookingMask();

	scrollAnimations();

	$(window).on('load', function() {
		$('.blog-sponsor').parallax();
	});

	personalizationUI();

	const splitModules = async () => {
		if ($('.js-form').length) {
			const formsUI = await import(/* webpackChunkName: "forms-ui" */ './forms-ui.js');
			formsUI.default();
		}
	}

	splitModules();

	let beHeader = document.querySelector("header.be-header");
	if(beHeader){
		var navLinksContainer = document.querySelector(".js-nav-links-container");
		var navTrigger = document.querySelector("#nav-trigger");

		if (navLinksContainer && navTrigger) {
			var listItems = navLinksContainer.querySelectorAll("li");

			if (listItems.length === 0) {
				navTrigger.style.display = "none";
			}
		}
	}

})(window, document, window.jQuery);


//solo-filter
let $soloCatFilterlist = document.querySelectorAll(".solo-filter");
if ($soloCatFilterlist.length > 0) {
	$soloCatFilterlist.forEach(soloCategoryFilterItem => {
		let $soloFilterInstance = new soloCategoryFilter(soloCategoryFilterItem);
		$soloFilterInstance.init();
	});
}


//Faq schema function
const generateSchema = (mainClass, questionClass, answerClass) => {
	let eleObj = {
		questionArray : [],
		answerArray : []
	}

	let questions = document.querySelectorAll(questionClass);
	let answers = document.querySelectorAll(answerClass);

	if (questions.length === 0 || answers.length === 0) {
		return;
	}
	questions.forEach(item => {
		let question = item.getAttribute("aria-label");
		eleObj['questionArray'].push(question); 
	});
	answers.forEach(item => {
		let answer = item.textContent;
		eleObj['answerArray'].push(answer);  
	});

	let mainEntities = [];
	for (let i = 0; i < eleObj.questionArray.length; i++) {
		let entity = {
				"@type": "Question",
				"name": eleObj.questionArray[i],
				"acceptedAnswer": {
						"@type": "Answer",
						"text": eleObj.answerArray[i]
				}
		};
		mainEntities.push(entity);
	}

	let jsonLD = `{
		"@context": "https://schema.org",
		"@type": "FAQPage",
		"mainEntity": [
				${mainEntities.map(entity => JSON.stringify(entity)).join(',')}
		]
	}`;

	let scriptElement = document.createElement('script');
	scriptElement.setAttribute('type', 'application/ld+json');
	scriptElement.textContent = jsonLD;
	let faqElement = document.querySelector(mainClass);

	if (!faqElement) {
		return; 
	}
	
	faqElement.appendChild(scriptElement);
}


const newsletterForm = document.querySelector(".custom-newsletter-block");
if(newsletterForm) {
  const newsletterGdpr = document.getElementById("newsletter-gdpr");

  newsletterGdpr.addEventListener('change', () => {
    if(newsletterGdpr.checked == false) {
      newsletterForm.querySelector('button[type="submit"]').classList.add('custom-gdpr-no');
    }else {
      newsletterForm.querySelector('button[type="submit"]').classList.remove('custom-gdpr-no');
    }
  })

  newsletterForm.querySelector('form')?.addEventListener('submit', (e) => {
    if(newsletterGdpr.checked == false) {
      newsletterForm.querySelector('button[type="submit"]').classList.add('custom-gdpr-no');
    }
  }); 
}

generateSchema(".section-faq", ".faq-question", ".faq-answer");
generateSchema(".faqs-category", ".faq-cat-question", ".faq-cat-answer");